import './congrats-block.css'
import React from 'react'

export const CongratsBlock = () => (
  <div className='congrats-block'>
    <b>Congrats! Enjoy your free pack!</b><br />
    Navigate  <a href="https://topps.atomichub.io/unbox/gpkpoolunbox/foodfight">here</a> to open your pack
  </div>
)